import querystring from 'querystring'
import Axios from './Axios'
import { ICategory } from './Categories'
import Uris from './Uris'
import formatUri from '../utils/formatUri'

export interface IPost {
  id?: number
  created?: string
  modified?: string
  category: ICategory | any
  slug?: string
  coverPage: string
  metaDescription: string
  title: string
  content: string
  date?: string
  publicated?: boolean
  visits?: number
}

export interface IPostWithPagination {
  count: number
  results: IPost[]
  next?: string
  previous?: string
}

export const create = async (post: FormData) => {
  const uri = '/api/blog/posts/'
  return Axios.post(uri, post)
}

export const getAllPosts = async (params): Promise<IPostWithPagination> => {
  const query = querystring.stringify(params)
  const uri = Uris.admin.blog.posts
  return Axios.get(`${uri}?${query}`)
}

export const getPost = async (slug: string): Promise<IPost> => {
  const uri = formatUri(Uris.admin.blog.post, slug)
  return Axios.get(uri)
}

export const remove = async (id) => {
  const uri = '/api/blog/posts/'
  return Axios.delete(`${uri}${id}/`)
}

export const update = async (slug: string, post: FormData) => {
  const uri = '/api/blog/posts/'
  return Axios.patch(`${uri}${slug}/`, post)
}

export const publish = async (slug: string, publicated: boolean): Promise<IPost> => {
  const uri = '/api/blog/posts/'
  return Axios.patch(`${uri}${slug}/`, { publicated })
}
